/**
 * @function: utils tool func
*/
import md5 from 'js-md5'

/**
 * 存储localStorage
 */
export const setStore = (name, content) => {
    if (!name) return;
    if (typeof content !== 'string') {
        content = JSON.stringify(content);
    }
    window.localStorage.setItem(name, content);
}

/**
 * 获取localStorage
 */
export const getStore = name => {
    if (!name) return;
    return window.localStorage.getItem(name);
}

/**
 * 删除localStorage
 */
export const removeStore = name => {
    if (!name) return;
    window.localStorage.removeItem(name);
}


/**
 * DataSign
 * @param data
 * @returns {*}
 */
export const getDataSign = data =>{
    return md5(getDataSignString(data));
}
/**
 * getMD5String
 * @param data
 * @returns {string}
 */
export const getMD5String = data =>{
    return md5(data);
}

/**
 * DataSignString
 * @param obj
 * @returns {string}
 */
export const getDataSignString = obj => {
    let datasign = '';
    let jsonObj = objKeySort(obj);
    for (let item in jsonObj) {
        if (datasign === '') {
            datasign = item + '=' + jsonObj[item]
        } else {
            datasign = datasign + '&' + item + '=' + jsonObj[item]
        }
    }
    datasign += 'hUuPd20171206LuOnD';
    return datasign;
}


/**
 *
 * @param dataObj
 */
export const objKeySort = dataObj => {
    let key = Object.keys(dataObj).sort();
    let obj = {};
    for (let i = 0; i < key.length; i++) {
        obj[key[i]] = dataObj[key[i]];
    }
    return obj;
}


/**
 * 时间戳
 * @returns {number}
 */
export const getTimeStamp = () => {
    return Date.parse(new Date()) / 1000;
}


/**
 * uuid
 * @returns {*}
 */
export const uuid = () => {
    function create(){
        let s = [];
        let hexDigits = "0123456789abcdef";
        for (var i = 0; i < 36; i++) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[14] = "4";
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
        s[8] = s[13] = s[18] = s[23] = "";
        let uuid = s.join("");
        return uuid;
    }

    if (!getStore('uuid')) {
        let uuid = create();
        setStore('uuid', uuid);
        return uuid;
    } else {
        return getStore('uuid');
    }
}

/**
 * validit
 * @return true| false
*/
export const  Validate =  {
    isMobile:  mobile => /^1[0-9]{10}$|^106[0-9]{9,12}$/.test(mobile) ? true : false,
    isImgCode: imgCode => imgCode.length != 4 ? false : true,
    isMsgCode: msgCode => /^\d{4}$/.test(msgCode) ? true : false,
    isPassWord: password => password.length < 6 ? false : true
}


/**
 * 过滤特殊字符
 * @param str
 * @returns {string|string}
 */
export const filterScript = (str) => {
    let pattern = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\]<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，.、？% -]");
    let suffix = str.slice(str.lastIndexOf('.'));
    let preTitle = str.slice(0, str.lastIndexOf('.'));
    let rs = "";
    for (let i = 0; i < preTitle.length; i++) {
        rs = rs + preTitle.substr(i, 1).replace(pattern, '');
    }
    rs = rs+suffix;
    rs = rs.trim();
    return rs;
}


/**
 * 翻转对象
 * @param obj
 */
export const reverseObj = (obj) => {
    let arr = [];
    for (let i in obj) {
        arr.push([obj[i],i]);
    }
    arr.reverse();
    let len = arr.length;
    let newObj = {};
    for (let i = 0; i < len; i++) {
        newObj[arr[i][1]] = arr[i][0];
    }
    return newObj;
}


/**
 * 格式化秒数
 * @param value
 * @returns {string}
 */
export const formatSeconds = (value) => {
    let h = Math.floor(value / 3600) < 10 ? '0' + Math.floor(value / 3600) : Math.floor(value / 3600);
    let m = Math.floor((value / 60 % 60)) < 10 ? '0' + Math.floor((value / 60 % 60)) : Math.floor((value / 60 % 60));
    let s = Math.floor((value % 60)) < 10 ? '0' + Math.floor((value % 60)) : Math.floor((value % 60));
    return  Math.floor(value / 3600) >= 1 ? h + ":" + m + ":" + s :  m + ":" + s;
}




/**
 *
 * @param size
 * @param pointLength
 * @param units
 * @returns {string}
 */
export const formatSize = (size, pointLength, units) => {
    let unit;
    units = units || ["B", "K", "M", "G", "TB"];
    while ((unit = units.shift()) && size > 1024) {
        size = size / 1024;
    }
    return (unit === "B" ? size : size.toFixed(pointLength || 2)) + unit;
}


